<div class="col-12 md:col-12 lg:col-12 container">

  <div class="grid container-header">
    <div class="col-12 md:col-12 lg:col-6">
      <span class="title">{{ 'TRANSLATE.NEW.PRICE' | translate }}</span>
    </div>
  </div>

  <div class="container-body">
    <form [formGroup]="userform" (ngSubmit)="buttonSave()">
      <div class="new-product-itens">

        <div class="col-12 md:col-12 lg:col-12 element-text-select">

          <div class="col-12 md:col-6 lg:col-4 element-option-select">
            <label class="element-option-select-filter" for="namePriceNew">{{ 'TRANSLATE.NAME.PRICE' | translate }}
            </label>
            <p-dropdown [options]="listNamePrice" id="namePriceNew" [autoDisplayFirst]="false"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}" formControlName="optionNamePrice"
              (onChange)="namePriceChange($event)" [style]="{'minWidth': '100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && selectedNamePrice === null && !userform.controls['optionNamePrice'].valid) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.NAME.PRICE' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-option-select space-left">
            <label class="element-option-select-filter" for="currencyNew">{{ 'TRANSLATE.CURRENCY' | translate }}
            </label>
            <p-dropdown [options]="listCurrency" id="currencyNew" [autoDisplayFirst]="false"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}" formControlName="optionCurrency"
              (onChange)="currencyChange($event)" [style]="{'minWidth': '100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && selectedCurrency === null && !userform.controls['optionCurrency'].valid) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.CURRENCY' | translate }}">
            </p-message>
            }
          </div>
          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-left">
            <label class="element-add-edit-label" for="priceValueNew">{{ 'TRANSLATE.VALUE' | translate }}
            </label>

            <input class="element-add-edit-input" id="priceValueNew" formControlName="inputPriceValue" type="text"
              minlength="1" maxlength="13" (input)="formatNumber($event)" pInputText>

            @if (isPriceValueEmpty()) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.INFORM.VALUE' | translate }}">
            </p-message>
            } @else if (isPriceValueZeroOrLess()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.VALUE.CANNOT.BE.ZERO.OR.LESS' | translate }}">
            </p-message>
            }
          </div>

        </div>

        <div class="col-12 md:col-12 lg:col-12 element-text-longe">

          <div class="col-12 md:col-12 lg:col-12 element-text-center textarea-row">
            <label class="element-text-center-label" for="priceDescriptionNew">{{ 'TRANSLATE.DESCRIPTION.PRICE' |
              translate }}
            </label>
            <textarea class="element-text-center-input" id="priceDescriptionNew" formControlName="inputPriceDescription"
              type="text" maxlength="100" pInputTextarea></textarea>

            <div class="char-counter">
              {{ userform.get('inputPriceDescription')?.value?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.100' |
              translate }}
            </div>

            @if (hasControlRequiredError('inputPriceDescription')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.DESCRIPTION.PRICE' | translate }}">
            </p-message>
            } @else if (hasControlMinLengthError('inputPriceDescription')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.PRICE.DESCRIPTION' | translate }}">
            </p-message>
            }
          </div>

        </div>

      </div>

      <div class="actions-section">
        <div class="col-12 md:col-12 lg:col-12 button-position">

          <button id="btnReturn" class="btn-return app-clean-button" type="button" (click)="buttonReturn()"
            [disabled]="isSaving">
            <i class="pi pi-arrow-left"></i>
            <span class="btn-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
          </button>

          <app-cta-button [label]="'TRANSLATE.SAVE'" [loadingLabel]="'TRANSLATE.SAVING'" [successState]="isCtaSuccess"
            [loading]="isSaving" (buttonClick)="buttonSave()">
          </app-cta-button>

        </div>
      </div>

    </form>
  </div>

</div>